// TXT-06 (Mario, 28-oct): la cascada de «Composición del neto». En cobranza no hay vendido: arranca en lo cobrado.
// TXT-07 (H-50): en cesión, el renglón «− Iniciales (las cobró el comercio)» entre lo vendido y las comisiones.
// Funciones puras (las prueba test/liquidacion-textos-release-28.test.mjs sin Angular).
const r2 = (n: any) => Math.round((Number(n) || 0) * 100) / 100;
/** DSC-07: un paso por concepto de `composicion.cargos` ([{ concepto, monto }]); «Cargo por uso» se muestra «Cargo por compra», al final. Sin desglose, «Cargos». */
const cargosDe = (c: any): any[] => {
  const lista = (Array.isArray(c.cargos) ? c.cargos : []).filter((x: any) => r2(x && x.monto) !== 0);
  if (!lista.length) return [['Cargos', -c.cargo, 'r']];
  const pasos: any[] = [], compra: any[] = [];
  let suma = 0;
  for (const x of lista) {
    const monto = r2(x.monto), nombre = String(x.concepto || '').trim();
    suma += monto;
    if (nombre.toLowerCase() === 'cargo por uso' || nombre === 'Cargo por compra') compra.push(monto); else pasos.push([nombre, -monto, 'r']);
  }
  // lo que el desglose no explica va al cargo por compra, para que los pasos sumen el cargo
  const resto = r2(compra.reduce((t, m) => t + m, 0) + (r2(c.cargo) - r2(suma)));
  if (resto !== 0) pasos.push(['Cargo por compra', -resto, 'r']);
  return pasos;
};

export const cascadaDe = (c: any): any[] => {
  if (!c) return [];
  const vendido = Number(c.vendido) || 0, cobrado = Number(c.cobrado) || 0, total = vendido + cobrado;
  if (!total) return [];
  const inicial = Number(c.inicial) || 0;
  const entra = [['Vendido', vendido], ['Cobrado', cobrado]].filter((e) => e[1]);
  const pasos = [...entra.map((e) => [e[0], e[1], 'b']), ...(inicial > 0 ? [['Iniciales (las cobró el comercio)', -inicial, 'r']] : []), ['Comisiones', -c.comision, 'r'], ...cargosDe(c), ['Ajustes y arrastres', c.ajustes, c.ajustes < 0 ? 'r' : 'b'], ['Neto al comercio', c.neto, 'n']];
  let base = 0;
  return pasos.map((p) => {
    const et = p[0], v = Number(p[1]) || 0, tipo = p[2];
    let desde = 0;
    if (tipo !== 'n') { desde = v < 0 ? base + v : base; base += v; }
    return { et, v, tipo, abs: Math.abs(v), desde: (desde / total) * 100, w: Math.max(0.6, (Math.abs(v) / total) * 100) };
  });
};

export const baseDeCreditotal = (c: any): string => {
  const vendido = Number(c && c.vendido) || 0, cobrado = Number(c && c.cobrado) || 0;
  return vendido && cobrado ? 'de lo vendido y cobrado' : cobrado ? 'de lo cobrado' : 'de lo vendido';
};
